import { useQuery } from '@tanstack/react-query';
import { ApiError } from './client';
import type { TvFeed } from './types';

/**
 * Flux d'un ecran TV, en polling conditionnel par ETag (304 = rien n'a change,
 * on ressert la derniere vue). Le jeton d'ecran vient de l'URL kiosque (?k=...).
 */
let lastEtag: string | null = null;
let lastData: TvFeed | null = null;

async function fetchTvFeed(token: string): Promise<TvFeed> {
  const response = await fetch('/api/tv/feed', {
    headers: { Authorization: `Bearer ${token}`, ...(lastEtag ? { 'If-None-Match': lastEtag } : {}) },
  });

  if (response.status === 304 && lastData) return lastData;

  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const err = (payload as { error?: { code: string; message: string } } | null)?.error;
    throw new ApiError(response.status, err?.code ?? 'UNKNOWN', err?.message ?? `Erreur ${response.status}`);
  }

  lastData = payload as TvFeed;
  lastEtag = response.headers.get('ETag');
  return lastData;
}

export function useTvFeed(token: string | null, refetchMs: number) {
  return useQuery({
    queryKey: ['tv-feed', token],
    queryFn: () => fetchTvFeed(token as string),
    enabled: !!token,
    refetchInterval: refetchMs,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
